// Closing a trial (customer decision of week 45): a trial never closes by itself. It is closed or reopened by a user
// (Close/Reopen in Trial Details), after an overview of its open tasks; when Final Report or Trial Done is done, the
// user is asked whether to close it now (task card and Edit Diary).

/** The tasks whose done date asks "Close the trial now?": Final Report (A35) and Trial Done (A45). */
export const CLOSING_TASKS = { A35: 'Final Report', A45: 'Trial Done' };

/** The name of a task that asks to close the trial ("Final Report"), or null for any other task. */
export const closingTaskName = (task) => CLOSING_TASKS[String(task?.vano ?? '').toUpperCase()] ?? null;

/** Whether a trial is closed (the API's 0/1 or a boolean). */
export const isTrialClosed = (trial) => trial?.Closed === true || Number(trial?.Closed) === 1;

/** A trial's open tasks: not done, not cancelled and not deleted. */
export const openTasks = (diaries) =>
  (Array.isArray(diaries) ? diaries : []).filter((d) => d && !d.donedate && !Number(d.cancelled) && !d.deleted_at && !d.delflag);
